<template>
	<div>
		<el-row class="contents">
			<!-- 查询条件 -->
			<el-col :span="24" class="handleQuery">
				<el-form :inline="true" :model="queryParams" class="form" size="small" label-width="80px">
					<el-form-item label="分类" label-width="60">
						<el-select v-model="queryParams.tags" filterable placeholder="请选择分类">
							<el-option label="全部" value=""></el-option>
							<el-option :key="tag" :label="tag" :value="tag" v-for="tag in allTags"></el-option>
						</el-select>
					</el-form-item>
					<el-form-item label="关键字"><el-input style="width:200px" v-model="queryParams.keyword" placeholder="请输入化学品代号、标签"></el-input></el-form-item>
					<el-form-item>
						<el-button type="primary" size="small" @click="handleQuery">查询</el-button>
						<el-button type="primary" size="small" @click="handleAdd">新增</el-button>
					</el-form-item>
				</el-form>
			</el-col>

			<!-- 列表 -->
			<el-col :span="24">
				<el-table v-loading="loading" :data="datas" stripe border style="width: 100%" ref="multipleTable" tooltip-effect="dark" @selection-change="handleSelectionChange"
					@sort-change="sortChange" :default-sort="queryParams.defaultSort">
					<el-table-column prop="code" label="化学品代号"></el-table-column>
					<el-table-column prop="title" label="标签"></el-table-column>
					<el-table-column prop="tags" label="化学品分类">
						<template slot-scope="scope" v-if="scope.row.tags">
							<el-tag v-for="(tag,index) in JSON.parse(scope.row.tags)" :key="index" type="">
								{{tag}}
							</el-tag>
						</template>
					</el-table-column>
					<el-table-column prop="file1" label="文件1">
						<template slot-scope="scope" v-if="scope.row.tags">
							<el-button size="mini" type="primary" @click="download(scope.row.file1)" :disabled="!scope.row.file1">下载</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="file2" label="文件2">
						<template slot-scope="scope" v-if="scope.row.tags">
							<el-button size="mini" type="primary" @click="download(scope.row.file2)" :disabled="!scope.row.file2">下载</el-button>
						</template>
					</el-table-column>
					<el-table-column prop="file3" label="文件3">
						<template slot-scope="scope" v-if="scope.row.tags">
							<el-button size="mini" type="primary" @click="download(scope.row.file3)" :disabled="!scope.row.file3">下载</el-button>
						</template>
					</el-table-column>
					<el-table-column label="状态" width="80px">
						<template slot-scope="scope">
							<el-switch v-model="scope.row.stateSw" @change="statusSwChange(scope.row)"></el-switch>
						</template>
					</el-table-column>
					<el-table-column prop="creatorName" label="创建人"></el-table-column>
					<el-table-column prop="createTime" label="创建时间"></el-table-column>
					<el-table-column fixed="right" label="操作" :width="width">
						<template slot-scope="scope">
							<el-button size="mini" type="primary" @click="handleEdit(scope.row)" v-has="'btn_edit'">编辑</el-button>
							<el-button size="mini" @click="handleDelete(scope.row)" type="danger" v-has="'btn_del'">删除</el-button>
						</template>
					</el-table-column>
				</el-table>

				<!-- 分页 -->
				<el-pagination background layout="total, sizes, prev, pager, next, jumper" :page-sizes="[10, 20, 30, 50, 100]" :current-page="queryParams.currentPage"
					:page-size="queryParams.pageSize" :total="totalNum" @size-change="pageSizeChange" @current-change="pageCurrentChange"></el-pagination>
			</el-col>
		</el-row>

		<!-- 新增/修改 -->
		<el-dialog :title="title" :visible.sync="dialogVisible" width="1000px" :close-on-click-modal="false" :before-close="closeBefore">
			<el-form :inline="true" :model="addOrUpdateForm" :rules="rules" ref="addOrUpdateForm" label-width="100px">
				<el-form-item label="化学品分类" prop="tags">
					<el-select v-model="addOrUpdateForm.tag" filterable reserve-keyword  placeholder="请输入变量分组,按enter键自动创建" 
					 @keyup.enter.native="handleEnter" @change="handleChange" ref="templateVariable">
						<el-option :key="tag" :label="tag" :value="tag" v-for="tag in allTags"></el-option>
					</el-select>
					<div style="width: 191px;">
						<el-tag size="mini" v-for="(tag,index) in tags" :key="index" closable type="" @close="handleRemoveTag(tag)" style="margin-top: 5px;margin-right:4px">
							{{tag}}
						</el-tag>
					</div>
					</el-input>
				</el-form-item>
				<el-form-item label="化学品代号" prop="code"><el-input type="text" placeholder="请输入化学品代号" v-model="addOrUpdateForm.code"></el-input></el-form-item>
				<el-form-item label="标签" prop="title"><el-input type="text" placeholder="请输入标签" v-model="addOrUpdateForm.title"></el-input></el-form-item>
				<el-form-item label="文件1" prop="file1">
					<div style="width: 191px;">
						<el-upload class="upload-demo" action="/api/system/file/upload" :multiple="false" :headers="headers" :on-success="handleUploadSuccess1"
							:file-list="fileList1" :on-exceed="handleExceed1" :limit="1" accept=".pdf" :on-remove="handleRemove1">
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
					</div>
					</el-input>
				</el-form-item>
				<el-form-item label="文件2" prop="file2">
					<div style="width: 191px;">
						<el-upload class="upload-demo" action="/api/system/file/upload" :multiple="false" :headers="headers" :on-success="handleUploadSuccess2"
							:file-list="fileList2" :on-exceed="handleExceed2" :limit="1" accept=".pdf" :on-remove="handleRemove2">
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
					</div>
					</el-input>
				</el-form-item>
				<el-form-item label="文件3" prop="file3">
					<div style="width: 191px;">
						<el-upload class="upload-demo" action="/api/system/file/upload" :multiple="false" :headers="headers" :on-success="handleUploadSuccess3"
							:file-list="fileList3" :on-exceed="handleExceed3" :limit="1" accept=".pdf" :on-remove="handleRemove3">
							<el-button size="small" type="primary">点击上传</el-button>
						</el-upload>
					</div>
				</el-form-item>
			</el-form>
			<div slot="footer" class="dialog-footer">
				<el-button size="small" @click="closeBefore()">取 消</el-button>
				<el-button size="small" type="primary" @click="handleUpdate">确 定</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
	import BaseSearch from '@/components/layout/base/base-search-front';

	export default {
		extends: BaseSearch,
		data() {
			return {
				url: 'mngr/chemicals',
				name: '化学品库',
				tags: [],
				rules: {
					code: [{
							required: true,
							message: '请输入化学品代号',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					title: [{
							required: true,
							message: '请输入标签',
							trigger: 'blur'
						},
						{
							max: 20,
							message: '长度最长支持20',
							trigger: 'blur'
						}
					],
					tags: [{
						required: true,
						message: '请输入化学品分类',
						trigger: 'blur',
						validator: this.checkArrayNotEmpty
					}],
				},
				fileList1: [],
				fileList2: [],
				fileList3: [],
				allTags: []
			};
		},
		filters: {},
		methods: {
			checkArrayNotEmpty(rule, value, callback) {
				value = JSON.parse(this.addOrUpdateForm[rule.field])
				if (value && value.length > 0) {
					callback();
				} else {
					callback(new Error(rule.message));
				}
			},
			createUpdateForm(row) {
				if (row) {
					var newObj = Object.assign({}, row); //复制对象, 避免表单与表格数据 双向绑定
					if (newObj.file1) {
						this.fileList1 = [JSON.parse(newObj.file1)]
					}
					if (newObj.file2) {
						this.fileList2 = [JSON.parse(newObj.file2)]
					}
					if (newObj.file3) {
						this.fileList3 = [JSON.parse(newObj.file3)]
					}
					this.addOrUpdateForm = newObj;
					if (this.addOrUpdateForm.tags) {
						this.tags = JSON.parse(this.addOrUpdateForm.tags)
					}
					this.$forceUpdate();
				} else {
					this.tags = []
					this.fileList1 = []
					this.fileList2 = []
					this.fileList3 = []
					this.addOrUpdateForm = {
						tags: []
					};
				}
			},
			beforeUpdate() {
				this.addOrUpdateForm.tags = JSON.stringify(this.tags);
			},
			handleUploadSuccess1(res, file) {
				this.addOrUpdateForm.file1 = JSON.stringify({
					name: file.name,
					url: res.data
				});
				this.$forceUpdate();
			},
			handleUploadSuccess2(res, file) {
				this.addOrUpdateForm.file2 = JSON.stringify({
					name: file.name,
					url: res.data
				});
				this.$forceUpdate();
			},
			afterUpdateState(){
				this.queryTags();
			},
			handleUploadSuccess3(res, file) {
				this.addOrUpdateForm.file3 = JSON.stringify({
					name: file.name,
					url: res.data
				});
				this.$forceUpdate();
			},
			handleExceed1(files, fileList) {
				this.fileList1 = [files[0]];
			},
			handleExceed2(files, fileList) {
				this.fileList2 = [files[0]];
			},
			handleExceed3(files, fileList) {
				this.fileList3 = [files[0]];
			},
			handleRemove1(file, fileList) {
				this.addOrUpdateForm.file1=""
			},
			handleRemove2(file, fileList) {
				this.addOrUpdateForm.file2=""
			},
			handleRemove3(file, fileList) {
				this.addOrUpdateForm.file3=""
			},
			handleChange(value){
				this.handleEnter(value)
			},
			handleEnter(tag) {
				if(!tag||tag instanceof KeyboardEvent){
					tag = this.$refs.templateVariable.selectedLabel
				}
				if (tag) {
					if (this.tags.indexOf(tag) == -1) {
						this.tags.push(tag)
						this.addOrUpdateForm.tag = ""
					} else {
						this.$message({
							message: '化学品分类' + tag + '已存在',
							type: 'warning'
						});
					}
				}
				this.addOrUpdateForm.tags = JSON.stringify(this.tags);
				this.$refs.templateVariable.blur();
			},
			handleRemoveTag(tag) {
				this.tags.splice(this.tags.indexOf(tag), 1);
				this.addOrUpdateForm.tags = JSON.stringify(this.tags);
			},
			queryTags() {
				this.$http({
					method: 'POST',
					url: 'mngr/chemicals/queryTags',
					data: {},
				}).then((res) => {
					this.allTags = res.data.data;
				})
			},
			download(file) {
				window.open(JSON.parse(file).url)
			},
			afterUpdate() {
				this.closeBefore();
				this.queryTags();
			},
			closeBefore(done) {
				this.fileList1 = []
				this.fileList2 = []
				this.fileList3 = []
				this.tags = []
				this.$refs['addOrUpdateForm'].resetFields();
				if (done) {
					done();
				} else {
					this.dialogVisible = false
				}
			},
		},
		mounted: function() {
			this.queryTags();
		}
	};
</script>

<style scoped>
	.el-dialog {
		width: 35% !important;
	}
</style>


// WEBPACK FOOTER //
// src/view/front/operation/chemicals.vue